<template>
<main-content>
    <kt-panel>
        <kt-panel-body v-if="ip_location !== 'IR'">
            <div class="alert alert-danger" role="alert">
                {{ $t('label.ir_ip_error') }}
            </div>
        </kt-panel-body>
        <kt-panel-body v-else>
            <dedicated-form :form_data="form_data" :submit="submit"></dedicated-form>
        </kt-panel-body>
    </kt-panel>
</main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import dedicatedForm from './components/form'
import $ from 'jquery'
import { KTApp } from '@/plugins/core/app'
import { dedicatedService, ipApi } from '@/common/api.service'
import { userTypes } from '@/constants/userTypes';
import { mapGetters } from 'vuex';

export default {
    components: {
        'main-content': mainContent,
        'dedicated-form': dedicatedForm
    },
    data() {
        return {
            user_types: userTypes,
            ip_location: '',
        }
    },
    mounted() {
        ipApi.ipLocation().then(response => {
            this.ip_location = response.data.countryCode;
        })
    },
    computed: {
        form_data: {
            get: function() {
                return this.$store.state.dedicated.form_data
            },
            set: function(value) {
                this.$store.commit('dedicated/setFormData', value)
            }
        },
        ...mapGetters('user', [
            'current_user'
        ]),
    },
    methods: {
        submit(e) {
            this.form_data.user_type = this.current_user.user_type;
            this.form_data.merchant_share_percent = $('#merchant_wage').val()
            let form = $('#dedicated_form')
            let btn = $('#submit_btn')

            form.validate({
                rules: {
                    birth_crtfct_number: {
                        required: () => {
                            return this.current_user.user_type == this.user_types.REAL;
                        },
                    },
                    birth_crtfct_serial: {
                        required: () => {
                            return this.current_user.user_type == this.user_types.REAL;
                        },
                    },
                    birth_crtfct_series_letter: {
                        required: () => {
                            return this.current_user.user_type == this.user_types.REAL;
                        },
                    },
                    birth_crtfct_series_number: {
                        required: () => {
                            return this.current_user.user_type == this.user_types.REAL;
                        },
                    },
                    gender: {
                        required: () => {
                            return this.current_user.user_type == this.user_types.REAL;
                        },
                    },
                    id_card_back: {
                        required: () => {
                            return this.current_user.user_type == this.user_types.REAL;
                        },
                    },
                    place_of_birth: {
                        required: () => {
                            return this.current_user.user_type == this.user_types.REAL;
                        },
                    },
                    place_of_birth_crtfct_issue: {
                        required: () => {
                            return this.current_user.user_type == this.user_types.REAL;
                        },
                    },
                    commercial_name: {
                        required: () => {
                            return this.current_user.user_type == this.user_types.LEGAL;
                        },
                    },
                    economic_code: {
                        required: () => {
                            return this.current_user.user_type == this.user_types.LEGAL;
                        },
                    },
                    tax_payer_code: {
                        required: () => {
                            return this.current_user.user_type == this.user_types.LEGAL;
                        },
                    },
                    place_of_registration: {
                        required: () => {
                            return this.current_user.user_type == this.user_types.LEGAL;
                        },
                    },
                    signatory_birth_crtfct_number: {
                        required: () => {
                            return this.current_user.user_type == this.user_types.LEGAL;
                        },
                    },
                    signatory_birth_crtfct_serial: {
                        required: () => {
                            return this.current_user.user_type == this.user_types.LEGAL;
                        },
                    },
                    signatory_birth_crtfct_series_letter: {
                        required: () => {
                            return this.current_user.user_type == this.user_types.LEGAL;
                        },
                    },
                    signatory_birth_crtfct_series_number: {
                        required: () => {
                            return this.current_user.user_type == this.user_types.LEGAL;
                        },
                    },
                    signatory_gender: {
                        required: () => {
                            return this.current_user.user_type == this.user_types.LEGAL;
                        },
                    },
                    signatory_id_card_back: {
                        required: () => {
                            return this.current_user.user_type == this.user_types.LEGAL;
                        },
                    },
                    farsi_name: {
                        required: true,
                    },
                    english_name: {
                        required: true,
                    },
                    address: {
                        required: true,
                    },
                    province: {
                        required: true,
                    },
                    city: {
                        required: true,
                    },
                    phone_number: {
                        required: true
                    },
                    ownership_type: {
                        required: true
                    },
                    rental_contract_number: {
                        required: () => {
                            return $("#ownership_type").val() == 1;
                        }
                    },
                    rental_expiry_date: {
                        required: () => {
                            return $("#ownership_type").val() == 1;
                        }
                    },
                    category_code: {
                        required: true,
                    },
                    bank_account_number: {
                        required: true
                    },
                    sheba_number: {
                        required: true
                    },
                    certificate_number: {
                        required: true
                    },
                    certificate_issue_date: {
                        required: true
                    },
                    certificate_expiry_date: {
                        required: true
                    },
                    etrust_certificate_type: {
                        required: true
                    },
                    etrust_certificate_issue_date: {
                        required: true
                    },
                    etrust_certificate_expiry_date: {
                        required: true
                    },
                    website_address: {
                        required: true,
                        url: true
                    },
                    business_type: {
                        required: true
                    },
                    programming_language: {
                        required: true
                    },
                    email: {
                        required: true
                    },
                    logo: {
                        required: true
                    },
                    wage: {
                        required: true
                    }
                }
            })

            if(!form.valid()) {
                return
            }

            KTApp.progress(btn)

            let params = this.form_data

            dedicatedService.create(params).then(response => {
                this.$router.push('/gateways')
            })
            .catch(({response}) => {
                if(response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message)
            })
            .finally(() => {
                KTApp.unprogress(btn)
            })
        },
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.$store.commit('dedicated/clearFormData')
        })
    },
}
</script>

<style>

</style>
